import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm, footerGroups, resultsDisclaimer } from "../data/site";
import { SiteLink } from "./SiteLink";
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-218" data-mp="3mh1206y44y0m">
      <div className="page-container py-14 md:py-16" data-id="element-219" data-mp="3mfpxg4wufm8g">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-220" data-mp="3hj7xrjgdee2z">
          <div className="md:col-span-6" data-id="element-221" data-mp="3hglsjqgycanx">
            <p className="text-h3 font-bold" data-id="element-222" data-mp="3dh4kcpa54zf2">{firm.legalName}</p>
            <p className="mt-1 text-white/80" data-id="element-223" data-mp="38hrnrctgwdza">
              {firm.attorney}, {firm.mark}
            </p>
            <a href={firm.phoneHref} className="mt-5 inline-flex min-h-[48px] items-center gap-3 text-h3 font-extrabold text-white hover:underline" data-id="element-224" data-mp="33iovksyl628q">
              <PhoneIcon aria-hidden="true" className="h-6 w-6" data-id="element-225" data-mp="2ylyb7tfr0khi" />
              {firm.phoneDisplay}
            </a>
            <div className="mt-3" data-id="element-226" data-mp="wsgyibcrgtfw">
              <SiteLink path="/contact-us/" className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline underline-offset-4" data-id="element-227" data-mp="wtimfgevlaf1">
                Contact the firm
              </SiteLink>
            </div>
          </div>
          {footerGroups.map(group => <nav key={group.id} aria-labelledby={group.id} className="md:col-span-3" data-id="element-228" data-mp="vtqvdqpdg0b2">
              <h2 id={group.id} className="text-label font-bold text-white/80" data-id="element-229" data-mp="10qz5d40d8y18">
                {group.label}
              </h2>
              <ul className="mt-3" data-id="element-230" data-mp="1ohv28fjoijfc">
                {group.links.map(link => <li key={link.path} data-id="element-231" data-mp="1tfejlobobcbi">
                    <SiteLink path={link.path} className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline-offset-4 hover:underline" data-id="element-232" data-mp="1tiaf7601tows">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/20 pt-6 text-meta text-white/80 md:flex-row md:justify-between" data-id="element-233" data-mp="2c8s5l3xes8ez">
          <p data-id="element-234" data-mp="2h3l3vlua2fcx">{resultsDisclaimer}</p>
          <div data-id="element-235" data-mp="2h4cnrzeiiond">
            <SiteLink path="/privacy-policy/" className="inline-flex min-h-[44px] items-center font-semibold text-white underline underline-offset-4" data-id="element-236" data-mp="2h1qg7zrmg955">Privacy Policy</SiteLink>
            <p data-id="element-237" data-mp="282mxwy0a3xrp">© 2026 {firm.legalName}</p>
          </div>
        </div>
      </div>
    </footer>;
}